// extracted by mini-css-extract-plugin
export default {"home":"c-i_cQ","home__background":"c-i_cR","home__content":"c-i_cS"};